module.exports = __webpack_public_path__ + "img/4-1.8689d402.svg";